import { styled, TextField } from '@mui/material';

const StyledTextField = styled(TextField)`
  input {
    font-size: 10px;
    background-color: #fcfcfc;
  }
  .MuiFormHelperText-root {
    margin: 0;
    font-size: 10px;
  }

  .MuiOutlinedInput-root {
    font-size: 12px;
    p {
      font-size: 12px;
    }
  }
`;

export default StyledTextField;
